import { Box } from "@outschool/backpack";
import { Checkbox } from "@outschool/ui-legacy-component-library";
import _ from "lodash";
import React from "react";

import * as Activity from "../../../../../shared/Activity";
import { Filter } from "../Filter";
import { ageFiltersToArray } from "../FilterFormat";
import { ListingChildFilterProps } from "./ListingFilters";

export default function AgeFilter({
  searchFilters,
  onChange,
}: ListingChildFilterProps) {
  const ages = ageFiltersToArray(searchFilters);
  const preventAutoFocusInputRef = React.useRef(null);

  const ageOptions = Activity.toddlerClassAgeOptions.concat(
    Activity.ageOptions,
  );

  // set focus on first age checkbox element (age 3) to address mobile ios
  // bug that focuses on a hidden text input element
  React.useEffect(() => {
    // perform a simple focus blur to prevent autofocus
    // @ts-ignore TS(2339): Property 'focus' does not exist on type 'never'.
    preventAutoFocusInputRef?.current?.focus();
    // @ts-ignore TS(2339): Property 'blur' does not exist on type 'never'.
    preventAutoFocusInputRef?.current?.blur();
  }, [preventAutoFocusInputRef]);

  return (
    <Filter showTopBorder={false}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 50px)",
          gridGap: "10px 17px",
          padding: "12px 24px 24px 0px",
        }}
      >
        {ageOptions.map((age: number) => (
          <Checkbox
            key={age}
            id={`${age}`}
            label={`${age}`}
            checked={ages.some(a => a === age)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const checked = e.target.checked;
              const newValues = checked ? [...ages, age] : _.without(ages, age);
              onChange?.({
                age: Array.isArray(newValues) ? newValues.join(",") : null,
              });
            }}
            sx={{
              fontSize: "0.9em",
              marginBottom: "medium",
            }}
            // send preventAutoFocusInputRef along with age 3 value to get
            // around mobile ios hidden text input focus bug
            ref={age === 3 ? preventAutoFocusInputRef : null}
          />
        ))}
      </Box>
    </Filter>
  );
}
